/*
 * isDesktop | isMobile
 *
 * sets window functions for isDesktop and isMobile
 * so they can be used throughout the campaign
 */
const breakpointDesktop = 768;
const breakpointDesktopXL = 992;

const isDesktop = () => window.innerWidth > breakpointDesktop;
const isDesktopXL = () => window.innerWidth > breakpointDesktopXL;
const isMobile = () => window.innerWidth <= breakpointDesktop;

export default {
  isDesktop,
  isDesktopXL,
  isMobile,
};
